export default "__VITE_ASSET__BdDlJTGx__"